export default "__VITE_ASSET__BxZXLTgu__"